export default __webpack_public_path__ + "static/media/university-of-ioannina-logo-remove.ed12c8bc.png";